module.exports = __webpack_public_path__ + "img/guide-icon1.80499b7f.png";